import { logOut } from './../util'

export {
    updateQrCode
};

async function updateQrCode({ token, setToken, navigate, updatedQrCode }) {
    if (!token)
        return logOut({ navigate, setToken })

    let status;

    fetch('/api/qr-codes/' + updatedQrCode._id, {
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token
        },
        body: JSON.stringify(updatedQrCode)
    })
        .then(response => {
            status = response.status;
            return response.json();
        })
        .then(json => {
            if (status !== 200) {
                if (status === 401) {
                    logOut({ navigate, setToken })
                }
                console.log(json.message);
                return false;
            }
            return json
        })
        .catch(err => {
            console.log(err)
            return false;
        })
}